export default __webpack_public_path__ + "static/media/Frostwall.85541295.jpg";